export const API_VERSION = {
    v1: 'api/v1.0/',
    v2: 'api/v1.1/'
};
